import { render, staticRenderFns } from "./UserSubmittionsPage.vue?vue&type=template&id=2058c33e&"
import script from "./UserSubmittionsPage.vue?vue&type=script&lang=js&"
export * from "./UserSubmittionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports